import React, { PureComponent, ReactElement } from 'react';
import { CourseActivity, RemoteActivity, RemoteOrganizer } from '../types';
import { toDateString } from '../utils';

interface ActivityItemProps extends RemoteActivity {
  organizers?: RemoteOrganizer[];
  activities?: CourseActivity[];
}

interface ActivityItemState {
  organizer?: RemoteOrganizer;
}

export default class ActivityItem extends PureComponent<ActivityItemProps, ActivityItemState> {
  static displayName = 'ActivityItem';
  constructor(props: ActivityItemProps) {
    super(props);
    const organizer = this.getOrganizer(props);
    this.state = {
      organizer,
    };
  }
  getOrganizer(props: ActivityItemProps): RemoteOrganizer | null {
    let organizer = null;
    if (props.organizer && props.organizers) {
      organizer = props.organizers.find((o) => `${o.id}` === `${props.organizer}`) || {};
    }
    return organizer;
  }
  componentDidUpdate(): void {
    const organizer = this.getOrganizer(this.props);
    if (organizer !== this.state.organizer) {
      this.setState({ organizer });
    }
  }
  render(): ReactElement {
    const extra = [];
    if (this.props.isBookedUp) {
      extra.push(
        <div key="isBookedUp" className="is-booked-up">
          Fullbokad
        </div>
      );
    }
    if (this.props.requiresMembership) {
      extra.push(
        <div key="requiresMembership" className="requires-membership">
          Medlemskap krävs
        </div>
      );
    }
    if (this.props.registrationFee) {
      extra.push(
        <div key="registrationFee" className="registration-fee">
          Anmälningsavgift: {this.props.registrationFee}
        </div>
      );
    }
    if (this.props.priceMember) {
      extra.push(
        <div key="priceMember" className="price-member">
          Pris medlem: {this.props.priceMember}
        </div>
      );
    }
    if (this.props.priceNonMember) {
      extra.push(
        <div key="priceNonMember" className="price-non-member">
          Pris icke medlem: {this.props.priceNonMember}
        </div>
      );
    }
    if (this.props.numberOfOccurrences) {
      extra.push(
        <div key="numberOfOccurrences" className="extra number-of-occurrences">
          Antal tillfällen: {this.props.numberOfOccurrences}
        </div>
      );
    }
    const time = [];
    if (this.props.day) {
      time.push(this.props.day);
    }
    if (this.props.date) {
      time.push(toDateString(this.props.date));
    }
    if (this.props.time) {
      time.push(this.props.time);
    }
    let bookButton;
    if (!this.props.bookable) {
      bookButton = (
        <a className="btn btn-default" href={this.props.url || `/node/${this.props.id}`}>
          Mer information
        </a>
      );
    } else if (this.props.isRegistrationOpen) {
      bookButton = (
        <a className="btn btn-default" href={this.props.link}>
          Boka här
        </a>
      );
    } else {
      bookButton = (
        <div className="activity-booking-link">
          <div className="message-box">
            <div className="message-icon icon-important" />
            <div className="message-text">Anmälan är stängd</div>
          </div>
        </div>
      );
    }

    return (
      <div className="ts-activity-item-row">
        <div className={`ts-activity-item-row-content ${this.props.imageUri ? 'has-image' : ''}`}>
          <div className="ts-activity-item-row-title">{this.props.title}</div>
          <div className="ts-activity-item-row-text" dangerouslySetInnerHTML={{ __html: this.props.description }} />
          <div className="ts-activity-item-row-footer clearfix" />
        </div>
        <div className="ts-activity-item-row-right">
          <div className="organizer">{(this.state.organizer && this.state.organizer.name) || ''}</div>
          <div className="ts-activity-item-row-social-info" />
          {extra}
          <div className="ts-activity-item-row-date">{time.join(' ')}</div>
          <div className="ts-activity-item-row-link">{bookButton}</div>
        </div>
      </div>
    );
  }
}
